import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1B3B6F] text-white">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Section */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/87917d4c1997ec0ae278ae84984ea976/1ea3e812b36acb9a2c88266f08973400.jpeg" 
                alt="NZ Constitution Logo" 
                className="h-10 w-10 object-contain"
              />
              <h3 className="text-2xl font-bold" style={{ fontFamily: 'Georgia, serif' }}>
                NZ Constitution 2.0
              </h3>
            </div>
            <p className="text-sm text-gray-300 mb-6 leading-relaxed">
              A new, clear, codified, foundational document for the nation.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-fill w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer"
                aria-label="Email"
              >
                <i className="ri-mail-fill w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {/* Contact Section */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-300 mb-4">
              Contact
            </h4>
            <p className="text-base mb-6">info@constitution.nz</p>
            <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-300 mb-4">
              Reference
            </h4>
            <p className="text-sm text-gray-300">Version 2.0</p>
            <p className="text-sm text-gray-300">Last Updated: 2024</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-300 mb-4">
              Quick Links
            </h4>
            <div className="space-y-3">
              <Link to="/" className="block text-base hover:text-gray-300 transition-colors cursor-pointer">
                About
              </Link>
              <Link to="/constitution" className="block text-base hover:text-gray-300 transition-colors cursor-pointer">
                The Constitution
              </Link>
              <Link to="/donate" className="block text-base hover:text-gray-300 transition-colors cursor-pointer">
                Donate
              </Link>
              <Link to="/contact" className="block text-base hover:text-gray-300 transition-colors cursor-pointer">
                Contact
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-300">
            &copy; {new Date().getFullYear()} NZ Constitution 2.0. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
              Terms
            </a>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
